export default "__VITE_ASSET__CNor_XgC__"